var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.label}},[_c('CSelect',_vm._b({attrs:{"options":_vm.options},on:{"update:value":function($event){return _vm.updateValue($event)}}},'CSelect',_vm.attributes(),false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }